import type { Lfa_Account_Settings__Input } from '~/graphql/types';
import removeTypenames from '~/util/removeTypenames';
import type { UpdateSettingsState } from '../../reducers/settingsReducer';
import type { ServicesV2State } from '../../reducers/servicesV2Reducer';
import serializeServicesV2Input from '~/components/page/Settings/LFASettings/servicesV2/utils/serialize';
import normalizeExcludedEmailDomainsForSubmit from '~/components/page/Settings/LFASettings/utils/normalizeExcludedEmailDomainsForSubmit';

const getUpdatedSettingsInput = (
  updateSettings: UpdateSettingsState,
  servicesV2: ServicesV2State,
): Lfa_Account_Settings__Input => {
  const {
    description,
    flynck,
    callbackPhoneNumber,
    services: updatedServices,
    ...rest
  } = updateSettings;

  const flynckSettings: Lfa_Account_Settings__Input['flynck'] = flynck
    ? {
        importSetupID: flynck.importSetupID,
        contextID: flynck.contextID,
      }
    : null;

  const updatedFields: Lfa_Account_Settings__Input = removeTypenames({
    ...rest,
    services: updatedServices.map(service => ({
      id: service.id,
      locations: service.locations
        .map(location =>
          location.enabled
            ? {
                type: location.type,
                note: location.note,
                weight: location.weight,
              }
            : null,
        )
        .filter(Boolean),
    })),
    rules: {
      ...rest.rules,
      minLeadscore: Number(rest.rules.minLeadscore),
      excludedEmailDomains: normalizeExcludedEmailDomainsForSubmit(
        rest.rules.excludedEmailDomains ?? [],
      ),
    },
    ...(description && { description }),
    ...(flynckSettings && { flynck: flynckSettings }),
    ...(callbackPhoneNumber && { callbackPhoneNumber }),
    servicesV2: servicesV2
      ? serializeServicesV2Input({
          credentials: servicesV2.credentials,
          calendars: servicesV2.calendars,
          accountServices: servicesV2.accountServices,
          officeChangesets: servicesV2.officeChangesets,
        })
      : null,
  });

  return updatedFields;
};
export default getUpdatedSettingsInput;
